import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as tagActions from '../../../../../../actions/tagAction';
import * as rateActions from "../../../../../../actions/rateAction";
import * as hotelActions from '../../../../../../actions/hotelAction';
import * as fnbActions from '../../../../../../actions/fnbAction';
import TagGroupDetailLinkSku from './TagGroupDetailLinkSku';

const mapStateToProps = state => {
  return {
    tagGroupDetailState: state.tagGroupDetailReducer,
    rateState: state.rateReducer,
    hotelState: state.hotelReducer,
    fnbState: state.fnbReducer,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTagGroupDetailItem: (id) => dispatch(tagActions.getTagGroupDetailItem(id)),
    setTagGroupDetailItem: (tagGroupDetail) => dispatch(tagActions.setTagGroupDetailItem(tagGroupDetail)),
    getAllSku: (typeKey) => dispatch(tagActions.getAllSku(typeKey)),
    mapSku: (params) => dispatch(tagActions.mapSkuAction(params)),
    mapSkuSuccess: () => dispatch(tagActions.mapSkuSuccess()),
    getListRatesByHotels: (filters) => dispatch(rateActions.getListRatesByHotels(filters)),
    getAllHotel: () => dispatch(hotelActions.getAllHotels()),
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TagGroupDetailLinkSku));
